// Common proto definitions shared across Admin and Customer services.
// Contains all core domain types: products, customers, orders, addresses,
// special offers, mini shops, order forms, skin problems, and usage tracking.

// @generated by protoc-gen-es v1.10.0 with parameter "target=ts"
// @generated from file common/common.proto (package mw.common, syntax proto3)
/* eslint-disable */
// @ts-nocheck

import type { BinaryReadOptions, FieldList, JsonReadOptions, JsonValue, PartialMessage, PlainMessage } from "@bufbuild/protobuf";
import { Message, proto3, protoInt64 } from "@bufbuild/protobuf";

/**
 * Top-level grouping used for order form sections and customer permissions.
 *
 * @generated from enum mw.common.MainCategory
 */
export enum MainCategory {
  /**
   * @generated from enum value: MAIN_CATEGORY_INVALID = 0;
   */
  INVALID = 0,

  /**
   * "Angebote" - special offers section
   *
   * @generated from enum value: MAIN_CATEGORY_OFFERS = 1;
   */
  OFFERS = 1,

  /**
   * "Makeup" - decorative cosmetics
   *
   * @generated from enum value: MAIN_CATEGORY_DECO = 2;
   */
  DECO = 2,

  /**
   * "Pflege" - skin care
   *
   * @generated from enum value: MAIN_CATEGORY_CARE = 3;
   */
  CARE = 3,

  /**
   * "Werbemittel" - promotional materials
   *
   * @generated from enum value: MAIN_CATEGORY_PROMOTION = 4;
   */
  PROMOTION = 4,
}
// Retrieve enum metadata with: proto3.getEnumType(MainCategory)
proto3.util.setEnumType(MainCategory, "mw.common.MainCategory", [
  { no: 0, name: "MAIN_CATEGORY_INVALID" },
  { no: 1, name: "MAIN_CATEGORY_OFFERS" },
  { no: 2, name: "MAIN_CATEGORY_DECO" },
  { no: 3, name: "MAIN_CATEGORY_CARE" },
  { no: 4, name: "MAIN_CATEGORY_PROMOTION" },
]);

/**
 * @generated from enum mw.common.AddressType
 */
export enum AddressType {
  /**
   * @generated from enum value: ADDRESS_TYPE_INVALID = 0;
   */
  INVALID = 0,

  /**
   * @generated from enum value: ADDRESS_TYPE_INVOICE = 1;
   */
  INVOICE = 1,

  /**
   * @generated from enum value: ADDRESS_TYPE_DELIVERY = 2;
   */
  DELIVERY = 2,
}
// Retrieve enum metadata with: proto3.getEnumType(AddressType)
proto3.util.setEnumType(AddressType, "mw.common.AddressType", [
  { no: 0, name: "ADDRESS_TYPE_INVALID" },
  { no: 1, name: "ADDRESS_TYPE_INVOICE" },
  { no: 2, name: "ADDRESS_TYPE_DELIVERY" },
]);

/**
 * @generated from enum mw.common.OrderStatus
 */
export enum OrderStatus {
  /**
   * @generated from enum value: ORDER_STATUS_INVALID = 0;
   */
  INVALID = 0,

  /**
   * Initial state for B2B orders.
   *
   * @generated from enum value: ORDER_STATUS_CREATED = 1;
   */
  CREATED = 1,

  /**
   * Sent to SAP for fulfillment.
   *
   * @generated from enum value: ORDER_STATUS_PROCESSED = 2;
   */
  PROCESSED = 2,

  /**
   * Shipped to the customer.
   *
   * @generated from enum value: ORDER_STATUS_SHIPPED = 3;
   */
  SHIPPED = 3,

  /**
   * Cancelled by admin.
   *
   * @generated from enum value: ORDER_STATUS_CANCELED = 4;
   */
  CANCELED = 4,

  /**
   * B2C / Mini Shop orders start here (PayPal intent created).
   *
   * @generated from enum value: ORDER_STATUS_INTENT = 5;
   */
  INTENT = 5,

  /**
   * PayPal intent creation failed.
   *
   * @generated from enum value: ORDER_STATUS_INTENT_ERROR = 6;
   */
  INTENT_ERROR = 6,

  /**
   * PayPal payment captured; ready for ORDER_STATUS_PROCESSED.
   *
   * @generated from enum value: ORDER_STATUS_CAPTURED = 7;
   */
  CAPTURED = 7,

  /**
   * PayPal capture failed.
   *
   * @generated from enum value: ORDER_STATUS_CAPTURE_ERROR = 8;
   */
  CAPTURE_ERROR = 8,
}
// Retrieve enum metadata with: proto3.getEnumType(OrderStatus)
proto3.util.setEnumType(OrderStatus, "mw.common.OrderStatus", [
  { no: 0, name: "ORDER_STATUS_INVALID" },
  { no: 1, name: "ORDER_STATUS_CREATED" },
  { no: 2, name: "ORDER_STATUS_PROCESSED" },
  { no: 3, name: "ORDER_STATUS_SHIPPED" },
  { no: 4, name: "ORDER_STATUS_CANCELED" },
  { no: 5, name: "ORDER_STATUS_INTENT" },
  { no: 6, name: "ORDER_STATUS_INTENT_ERROR" },
  { no: 7, name: "ORDER_STATUS_CAPTURED" },
  { no: 8, name: "ORDER_STATUS_CAPTURE_ERROR" },
]);

/**
 * @generated from enum mw.common.OrderType
 */
export enum OrderType {
  /**
   * @generated from enum value: ORDER_TYPE_INVALID = 0;
   */
  INVALID = 0,

  /**
   * Mini Shop prospect order (Kennenlern-Kunde) - uses collective SAP customer.
   *
   * @generated from enum value: ORDER_TYPE_COLLECTIVE = 1;
   */
  COLLECTIVE = 1,

  /**
   * Regular B2B customer order - uses individual SAP customer.
   *
   * @generated from enum value: ORDER_TYPE_DEDICATED = 2;
   */
  DEDICATED = 2,

  /**
   * Student order (Schueler) - uses shared SAP customer 1000023.
   *
   * @generated from enum value: ORDER_TYPE_COLLECTIVE_STUDENT = 3;
   */
  COLLECTIVE_STUDENT = 3,
}
// Retrieve enum metadata with: proto3.getEnumType(OrderType)
proto3.util.setEnumType(OrderType, "mw.common.OrderType", [
  { no: 0, name: "ORDER_TYPE_INVALID" },
  { no: 1, name: "ORDER_TYPE_COLLECTIVE" },
  { no: 2, name: "ORDER_TYPE_DEDICATED" },
  { no: 3, name: "ORDER_TYPE_COLLECTIVE_STUDENT" },
]);

/**
 * @generated from enum mw.common.PaymentType
 */
export enum PaymentType {
  /**
   * @generated from enum value: PAYMENT_TYPE_INVALID = 0;
   */
  INVALID = 0,

  /**
   * PayPal (primary payment for B2C/students).
   *
   * @generated from enum value: PAYMENT_TYPE_PAYPAL = 1;
   */
  PAYPAL = 1,

  /**
   * Invoice / contract billing (B2B customers).
   *
   * @generated from enum value: PAYMENT_TYPE_CONTRACT = 2;
   */
  CONTRACT = 2,

  /**
   * Invoice payment (students: only after successful PayPal order and < 1000 EUR).
   *
   * @generated from enum value: PAYMENT_TYPE_INVOICE = 3;
   */
  INVOICE = 3,
}
// Retrieve enum metadata with: proto3.getEnumType(PaymentType)
proto3.util.setEnumType(PaymentType, "mw.common.PaymentType", [
  { no: 0, name: "PAYMENT_TYPE_INVALID" },
  { no: 1, name: "PAYMENT_TYPE_PAYPAL" },
  { no: 2, name: "PAYMENT_TYPE_CONTRACT" },
  { no: 3, name: "PAYMENT_TYPE_INVOICE" },
]);

/**
 * @generated from enum mw.common.SpecialOfferType
 */
export enum SpecialOfferType {
  /**
   * @generated from enum value: SPECIAL_OFFER_TYPE_INVALID = 0;
   */
  INVALID = 0,

  /**
   * Banner offer - shown as a promotional banner on the order form.
   *
   * @generated from enum value: SPECIAL_OFFER_TYPE_BANNER = 1;
   */
  BANNER = 1,

  /**
   * Single-use code - one code valid for all customers.
   *
   * @generated from enum value: SPECIAL_OFFER_TYPE_SINGLE_CODE = 2;
   */
  SINGLE_CODE = 2,

  /**
   * Multi-use code - unique codes per customer.
   *
   * @generated from enum value: SPECIAL_OFFER_TYPE_MULTI_CODE = 3;
   */
  MULTI_CODE = 3,
}
// Retrieve enum metadata with: proto3.getEnumType(SpecialOfferType)
proto3.util.setEnumType(SpecialOfferType, "mw.common.SpecialOfferType", [
  { no: 0, name: "SPECIAL_OFFER_TYPE_INVALID" },
  { no: 1, name: "SPECIAL_OFFER_TYPE_BANNER" },
  { no: 2, name: "SPECIAL_OFFER_TYPE_SINGLE_CODE" },
  { no: 3, name: "SPECIAL_OFFER_TYPE_MULTI_CODE" },
]);

/**
 * @generated from enum mw.common.ImageType
 */
export enum ImageType {
  /**
   * @generated from enum value: IMAGE_TYPE_INVALID = 0;
   */
  INVALID = 0,

  /**
   * Navigation menu tile.
   *
   * @generated from enum value: IMAGE_TYPE_MENU = 1;
   */
  MENU = 1,

  /**
   * Shop / detail page image.
   *
   * @generated from enum value: IMAGE_TYPE_SHOP = 2;
   */
  SHOP = 2,
}
// Retrieve enum metadata with: proto3.getEnumType(ImageType)
proto3.util.setEnumType(ImageType, "mw.common.ImageType", [
  { no: 0, name: "IMAGE_TYPE_INVALID" },
  { no: 1, name: "IMAGE_TYPE_MENU" },
  { no: 2, name: "IMAGE_TYPE_SHOP" },
]);

/**
 * @generated from enum mw.common.UsageType
 */
export enum UsageType {
  /**
   * @generated from enum value: USAGE_TYPE_INVALID = 0;
   */
  INVALID = 0,

  /**
   * First visit to a mini shop.
   *
   * @generated from enum value: USAGE_TYPE_INITIAL_VISIT = 1;
   */
  INITIAL_VISIT = 1,

  /**
   * Return visit.
   *
   * @generated from enum value: USAGE_TYPE_SUBSEQUENT_VISIT = 2;
   */
  SUBSEQUENT_VISIT = 2,

  /**
   * Visit resulted in an error (e.g. shop not found).
   *
   * @generated from enum value: USAGE_TYPE_VISIT_ERROR = 3;
   */
  VISIT_ERROR = 3,

  /**
   * Order lifecycle events.
   *
   * @generated from enum value: USAGE_TYPE_MINI_SHOP_CREATE_ORDER = 4;
   */
  MINI_SHOP_CREATE_ORDER = 4,

  /**
   * @generated from enum value: USAGE_TYPE_MINI_SHOP_CREATE_ORDER_VALIDATION_ERROR = 5;
   */
  MINI_SHOP_CREATE_ORDER_VALIDATION_ERROR = 5,

  /**
   * @generated from enum value: USAGE_TYPE_MINI_SHOP_CREATE_ORDER_ERROR = 6;
   */
  MINI_SHOP_CREATE_ORDER_ERROR = 6,

  /**
   * @generated from enum value: USAGE_TYPE_MINI_SHOP_CAPTURE_ORDER = 7;
   */
  MINI_SHOP_CAPTURE_ORDER = 7,

  /**
   * @generated from enum value: USAGE_TYPE_MINI_SHOP_CAPTURE_ORDER_ERROR = 8;
   */
  MINI_SHOP_CAPTURE_ORDER_ERROR = 8,

  /**
   * @generated from enum value: USAGE_TYPE_MINI_SHOP_CANCEL_ORDER = 9;
   */
  MINI_SHOP_CANCEL_ORDER = 9,

  /**
   * @generated from enum value: USAGE_TYPE_MINI_SHOP_ERROR_ORDER = 10;
   */
  MINI_SHOP_ERROR_ORDER = 10,
}
// Retrieve enum metadata with: proto3.getEnumType(UsageType)
proto3.util.setEnumType(UsageType, "mw.common.UsageType", [
  { no: 0, name: "USAGE_TYPE_INVALID" },
  { no: 1, name: "USAGE_TYPE_INITIAL_VISIT" },
  { no: 2, name: "USAGE_TYPE_SUBSEQUENT_VISIT" },
  { no: 3, name: "USAGE_TYPE_VISIT_ERROR" },
  { no: 4, name: "USAGE_TYPE_MINI_SHOP_CREATE_ORDER" },
  { no: 5, name: "USAGE_TYPE_MINI_SHOP_CREATE_ORDER_VALIDATION_ERROR" },
  { no: 6, name: "USAGE_TYPE_MINI_SHOP_CREATE_ORDER_ERROR" },
  { no: 7, name: "USAGE_TYPE_MINI_SHOP_CAPTURE_ORDER" },
  { no: 8, name: "USAGE_TYPE_MINI_SHOP_CAPTURE_ORDER_ERROR" },
  { no: 9, name: "USAGE_TYPE_MINI_SHOP_CANCEL_ORDER" },
  { no: 10, name: "USAGE_TYPE_MINI_SHOP_ERROR_ORDER" },
]);

/**
 * @generated from enum mw.common.OrderFormProductStatus
 */
export enum OrderFormProductStatus {
  /**
   * Not yet configured (default/unset state).
   *
   * @generated from enum value: ORDER_FORM_PRODUCT_STATUS_INVALID = 0;
   */
  INVALID = 0,

  /**
   * Enabled - visible in the order form.
   *
   * @generated from enum value: ORDER_FORM_PRODUCT_STATUS_ENABLED = 1;
   */
  ENABLED = 1,

  /**
   * Disabled - hidden from the order form.
   *
   * @generated from enum value: ORDER_FORM_PRODUCT_STATUS_DISABLED = 2;
   */
  DISABLED = 2,
}
// Retrieve enum metadata with: proto3.getEnumType(OrderFormProductStatus)
proto3.util.setEnumType(OrderFormProductStatus, "mw.common.OrderFormProductStatus", [
  { no: 0, name: "ORDER_FORM_PRODUCT_STATUS_INVALID" },
  { no: 1, name: "ORDER_FORM_PRODUCT_STATUS_ENABLED" },
  { no: 2, name: "ORDER_FORM_PRODUCT_STATUS_DISABLED" },
]);

/**
 * Category represents a product category from SAP (e.g. "Nail Lacquer", "Foundation").
 *
 * @generated from message mw.common.Category
 */
export class Category extends Message<Category> {
  /**
   * @generated from field: int32 id = 1;
   */
  id = 0;

  /**
   * Category nesting depth (1 = top-level, 2 = subcategory, etc.)
   *
   * @generated from field: int32 level = 2;
   */
  level = 0;

  /**
   * Machine-readable identifier used in code lookups.
   *
   * @generated from field: string identifier = 3;
   */
  identifier = "";

  /**
   * Display name in SAP / backend.
   *
   * @generated from field: string title = 4;
   */
  title = "";

  /**
   * Optional override for the order form display name.
   *
   * @generated from field: string order_form_title = 5;
   */
  orderFormTitle = "";

  /**
   * Sort position within the order form.
   *
   * @generated from field: int32 order_form_order = 6;
   */
  orderFormOrder = 0;

  /**
   * FK to the parent product category.
   *
   * @generated from field: int32 product_category_id = 7;
   */
  productCategoryId = 0;

  constructor(data?: PartialMessage<Category>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "mw.common.Category";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "id", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
    { no: 2, name: "level", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
    { no: 3, name: "identifier", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 4, name: "title", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 5, name: "order_form_title", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 6, name: "order_form_order", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
    { no: 7, name: "product_category_id", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): Category {
    return new Category().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): Category {
    return new Category().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): Category {
    return new Category().fromJsonString(jsonString, options);
  }

  static equals(a: Category | PlainMessage<Category> | undefined, b: Category | PlainMessage<Category> | undefined): boolean {
    return proto3.util.equals(Category, a, b);
  }
}

/**
 * Customer represents a B2B customer or student (B2C) account.
 * Synced from SAP; students are managed via the student registration workflow.
 *
 * @generated from message mw.common.Customer
 */
export class Customer extends Message<Customer> {
  /**
   * Internal GUID (primary key in our database).
   *
   * @generated from field: string id = 1;
   */
  id = "";

  /**
   * SAP customer number. Students all share SAP ID 1000023.
   *
   * @generated from field: uint64 sap_id = 5;
   */
  sapId = protoInt64.zero;

  /**
   * Legacy ID from the old system (migration reference).
   *
   * @generated from field: uint64 legacy_id = 6;
   */
  legacyId = protoInt64.zero;

  /**
   * @generated from field: string email = 7;
   */
  email = "";

  /**
   * Hashed password (never sent to clients).
   *
   * @generated from field: string password = 8;
   */
  password = "";

  /**
   * Company or first name.
   *
   * @generated from field: string name1 = 9;
   */
  name1 = "";

  /**
   * Contact person or last name.
   *
   * @generated from field: string name2 = 10;
   */
  name2 = "";

  /**
   * @generated from field: string street = 11;
   */
  street = "";

  /**
   * @generated from field: string zip = 12;
   */
  zip = "";

  /**
   * @generated from field: string city = 13;
   */
  city = "";

  /**
   * ISO country code (e.g. "DE", "AT").
   *
   * @generated from field: string country = 14;
   */
  country = "";

  /**
   * @generated from field: string phone = 15;
   */
  phone = "";

  /**
   * @generated from field: string mobile = 16;
   */
  mobile = "";

  /**
   * @generated from field: string fax = 17;
   */
  fax = "";

  /**
   * @generated from field: string website = 18;
   */
  website = "";

  /**
   * SAP classification code.
   *
   * @generated from field: string classification = 19;
   */
  classification = "";

  /**
   * Product category access flags (1 = allowed, 0 = not allowed).
   * Determines which sections of the order form this customer can see.
   *
   * @generated from field: int32 care_products = 20;
   */
  careProducts = 0;

  /**
   * @generated from field: int32 deco_products = 21;
   */
  decoProducts = 0;

  /**
   * @generated from field: int32 hairdresser_products = 22;
   */
  hairdresserProducts = 0;

  /**
   * @generated from field: int32 detox_products = 23;
   */
  detoxProducts = 0;

  /**
   * 1 = blocked, 0 = active. Blocked customers cannot log in.
   *
   * @generated from field: int32 blocked = 24;
   */
  blocked = 0;

  /**
   * Internal admin notes (not visible to the customer).
   *
   * @generated from field: string internal_note = 25;
   */
  internalNote = "";

  /**
   * One-time activation code for first login / password reset.
   *
   * @generated from field: string activation_code = 26;
   */
  activationCode = "";

  /**
   * Timestamps (ISO 8601 format).
   *
   * @generated from field: string first_login = 27;
   */
  firstLogin = "";

  /**
   * @generated from field: string last_login = 28;
   */
  lastLogin = "";

  /**
   * @generated from field: string created_at = 29;
   */
  createdAt = "";

  /**
   * @generated from field: string updated_at = 30;
   */
  updatedAt = "";

  /**
   * Special offers assigned to this customer.
   *
   * @generated from field: repeated mw.common.SpecialOffer special_offers = 31;
   */
  specialOffers: SpecialOffer[] = [];

  /**
   * Optional separate delivery address.
   *
   * @generated from field: string delivery_name1 = 32;
   */
  deliveryName1 = "";

  /**
   * @generated from field: string delivery_name2 = 33;
   */
  deliveryName2 = "";

  /**
   * @generated from field: string delivery_street = 34;
   */
  deliveryStreet = "";

  /**
   * @generated from field: string delivery_zip = 35;
   */
  deliveryZip = "";

  /**
   * @generated from field: string delivery_city = 36;
   */
  deliveryCity = "";

  /**
   * @generated from field: string delivery_country = 37;
   */
  deliveryCountry = "";

  /**
   * @generated from field: string delivery_phone = 38;
   */
  deliveryPhone = "";

  /**
   * Whether a separate delivery address is active.
   *
   * @generated from field: bool delivery_address = 39;
   */
  deliveryAddress = false;

  /**
   * Student-specific fields (B2C pricing with 10% discount).
   * Students must upload verification documents and be approved by admin.
   *
   * @generated from field: int32 student_products = 40;
   */
  studentProducts = 0;

  /**
   * 0 = not verified, 1 = verified.
   *
   * @generated from field: int32 student_verified = 41;
   */
  studentVerified = 0;

  /**
   * Verification validity period (ISO 8601 date strings).
   *
   * @generated from field: string student_verification_start = 42;
   */
  studentVerificationStart = "";

  /**
   * @generated from field: string student_verification_end = 43;
   */
  studentVerificationEnd = "";

  /**
   * Number of completed PayPal orders (used to determine invoice eligibility).
   *
   * @generated from field: int32 student_paypal_order_count = 44;
   */
  studentPaypalOrderCount = 0;

  /**
   * Reason if student verification was rejected.
   *
   * @generated from field: string rejection_reason = 45;
   */
  rejectionReason = "";

  constructor(data?: PartialMessage<Customer>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "mw.common.Customer";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 5, name: "sap_id", kind: "scalar", T: 4 /* ScalarType.UINT64 */ },
    { no: 6, name: "legacy_id", kind: "scalar", T: 4 /* ScalarType.UINT64 */ },
    { no: 7, name: "email", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 8, name: "password", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 9, name: "name1", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 10, name: "name2", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 11, name: "street", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 12, name: "zip", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 13, name: "city", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 14, name: "country", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 15, name: "phone", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 16, name: "mobile", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 17, name: "fax", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 18, name: "website", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 19, name: "classification", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 20, name: "care_products", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
    { no: 21, name: "deco_products", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
    { no: 22, name: "hairdresser_products", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
    { no: 23, name: "detox_products", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
    { no: 24, name: "blocked", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
    { no: 25, name: "internal_note", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 26, name: "activation_code", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 27, name: "first_login", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 28, name: "last_login", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 29, name: "created_at", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 30, name: "updated_at", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 31, name: "special_offers", kind: "message", T: SpecialOffer, repeated: true },
    { no: 32, name: "delivery_name1", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 33, name: "delivery_name2", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 34, name: "delivery_street", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 35, name: "delivery_zip", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 36, name: "delivery_city", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 37, name: "delivery_country", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 38, name: "delivery_phone", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 39, name: "delivery_address", kind: "scalar", T: 8 /* ScalarType.BOOL */ },
    { no: 40, name: "student_products", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
    { no: 41, name: "student_verified", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
    { no: 42, name: "student_verification_start", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 43, name: "student_verification_end", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 44, name: "student_paypal_order_count", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
    { no: 45, name: "rejection_reason", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): Customer {
    return new Customer().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): Customer {
    return new Customer().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): Customer {
    return new Customer().fromJsonString(jsonString, options);
  }

  static equals(a: Customer | PlainMessage<Customer> | undefined, b: Customer | PlainMessage<Customer> | undefined): boolean {
    return proto3.util.equals(Customer, a, b);
  }
}

/**
 * Address represents a postal address for invoicing or delivery.
 *
 * @generated from message mw.common.Address
 */
export class Address extends Message<Address> {
  /**
   * @generated from field: mw.common.AddressType address_type = 1;
   */
  addressType = AddressType.INVALID;

  /**
   * @generated from field: string name1 = 2;
   */
  name1 = "";

  /**
   * @generated from field: string name2 = 3;
   */
  name2 = "";

  /**
   * @generated from field: string street = 4;
   */
  street = "";

  /**
   * @generated from field: string zip = 5;
   */
  zip = "";

  /**
   * @generated from field: string city = 6;
   */
  city = "";

  /**
   * ISO country code.
   *
   * @generated from field: string country = 7;
   */
  country = "";

  constructor(data?: PartialMessage<Address>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "mw.common.Address";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "address_type", kind: "enum", T: proto3.getEnumType(AddressType) },
    { no: 2, name: "name1", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 3, name: "name2", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 4, name: "street", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 5, name: "zip", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 6, name: "city", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 7, name: "country", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): Address {
    return new Address().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): Address {
    return new Address().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): Address {
    return new Address().fromJsonString(jsonString, options);
  }

  static equals(a: Address | PlainMessage<Address> | undefined, b: Address | PlainMessage<Address> | undefined): boolean {
    return proto3.util.equals(Address, a, b);
  }
}

/**
 * Product represents a single SKU from the SAP product catalog.
 *
 * @generated from message mw.common.Product
 */
export class Product extends Message<Product> {
  /**
   * Internal GUID.
   *
   * @generated from field: string id = 1;
   */
  id = "";

  /**
   * SAP material number.
   *
   * @generated from field: uint64 sap_id = 2;
   */
  sapId = protoInt64.zero;

  /**
   * FK to Category.
   *
   * @generated from field: uint32 product_category_id = 3;
   */
  productCategoryId = 0;

  /**
   * EAN / barcode.
   *
   * @generated from field: string ean = 4;
   */
  ean = "";

  /**
   * SAP model number (e.g. "40.10080").
   *
   * @generated from field: string model_number = 5;
   */
  modelNumber = "";

  /**
   * @generated from field: string name_de = 6;
   */
  nameDe = "";

  /**
   * @generated from field: string name_en = 7;
   */
  nameEn = "";

  /**
   * 1 = blocked from ordering.
   *
   * @generated from field: int32 blocked = 8;
   */
  blocked = 0;

  /**
   * B2B price (wholesale, regular customers get 3% discount).
   *
   * @generated from field: float price_b2b = 9;
   */
  priceB2b = 0;

  /**
   * B2C price (retail, students get 10% discount).
   *
   * @generated from field: float price_b2c = 10;
   */
  priceB2c = 0;

  /**
   * Product category flags (1 = belongs to category).
   *
   * @generated from field: int32 care_product = 11;
   */
  careProduct = 0;

  /**
   * @generated from field: int32 deco_product = 12;
   */
  decoProduct = 0;

  /**
   * @generated from field: int32 hairdresser_product = 13;
   */
  hairdresserProduct = 0;

  /**
   * @generated from field: int32 detox_product = 14;
   */
  detoxProduct = 0;

  /**
   * Current stock quantity from SAP.
   *
   * @generated from field: float stock = 15;
   */
  stock = 0;

  /**
   * INCI ingredients list.
   *
   * @generated from field: string ingredients = 16;
   */
  ingredients = "";

  /**
   * Units per sales package (e.g. 6.0 for a 6-pack).
   *
   * @generated from field: float quantity_per_pack = 17;
   */
  quantityPerPack = 0;

  /**
   * SAP unit key (e.g. "ST" for Stueck).
   *
   * @generated from field: string quantity_unit_key = 18;
   */
  quantityUnitKey = "";

  /**
   * @generated from field: string quantity_unit_name = 19;
   */
  quantityUnitName = "";

  /**
   * Product line identifier (e.g. "40" for Foundation line).
   *
   * @generated from field: string product_line_key = 20;
   */
  productLineKey = "";

  /**
   * @generated from field: string product_line_name = 21;
   */
  productLineName = "";

  /**
   * Variant info (e.g. color name, shade).
   *
   * @generated from field: string variant_name = 22;
   */
  variantName = "";

  /**
   * Variant number (e.g. "23" in model number "40.10023").
   *
   * @generated from field: string variant_number = 23;
   */
  variantNumber = "";

  /**
   * @generated from field: string internal_note = 24;
   */
  internalNote = "";

  /**
   * Timestamps (ISO 8601).
   *
   * @generated from field: string created_at = 25;
   */
  createdAt = "";

  /**
   * @generated from field: string updated_at = 26;
   */
  updatedAt = "";

  /**
   * Soft-delete timestamp; empty if active.
   *
   * @generated from field: string deleted_at = 27;
   */
  deletedAt = "";

  /**
   * @generated from field: string product_category_name = 28;
   */
  productCategoryName = "";

  /**
   * @generated from field: int32 product_category_level = 29;
   */
  productCategoryLevel = 0;

  /**
   * Minimum order quantity. 0 = no minimum; > 0 = must order at least this many.
   *
   * @generated from field: int32 minimal_order_quantity = 30;
   */
  minimalOrderQuantity = 0;

  /**
   * Google Shopping product ID.
   *
   * @generated from field: string google_id = 31;
   */
  googleId = "";

  /**
   * Grouping key for product families.
   *
   * @generated from field: string product_group = 32;
   */
  productGroup = "";

  /**
   * Marketing description.
   *
   * @generated from field: string description = 33;
   */
  description = "";

  /**
   * Special offers that apply to this product.
   *
   * @generated from field: repeated mw.common.SpecialOffer special_offers = 34;
   */
  specialOffers: SpecialOffer[] = [];

  constructor(data?: PartialMessage<Product>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "mw.common.Product";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "sap_id", kind: "scalar", T: 4 /* ScalarType.UINT64 */ },
    { no: 3, name: "product_category_id", kind: "scalar", T: 13 /* ScalarType.UINT32 */ },
    { no: 4, name: "ean", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 5, name: "model_number", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 6, name: "name_de", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 7, name: "name_en", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 8, name: "blocked", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
    { no: 9, name: "price_b2b", kind: "scalar", T: 2 /* ScalarType.FLOAT */ },
    { no: 10, name: "price_b2c", kind: "scalar", T: 2 /* ScalarType.FLOAT */ },
    { no: 11, name: "care_product", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
    { no: 12, name: "deco_product", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
    { no: 13, name: "hairdresser_product", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
    { no: 14, name: "detox_product", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
    { no: 15, name: "stock", kind: "scalar", T: 2 /* ScalarType.FLOAT */ },
    { no: 16, name: "ingredients", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 17, name: "quantity_per_pack", kind: "scalar", T: 2 /* ScalarType.FLOAT */ },
    { no: 18, name: "quantity_unit_key", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 19, name: "quantity_unit_name", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 20, name: "product_line_key", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 21, name: "product_line_name", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 22, name: "variant_name", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 23, name: "variant_number", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 24, name: "internal_note", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 25, name: "created_at", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 26, name: "updated_at", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 27, name: "deleted_at", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 28, name: "product_category_name", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 29, name: "product_category_level", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
    { no: 30, name: "minimal_order_quantity", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
    { no: 31, name: "google_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 32, name: "product_group", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 33, name: "description", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 34, name: "special_offers", kind: "message", T: SpecialOffer, repeated: true },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): Product {
    return new Product().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): Product {
    return new Product().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): Product {
    return new Product().fromJsonString(jsonString, options);
  }

  static equals(a: Product | PlainMessage<Product> | undefined, b: Product | PlainMessage<Product> | undefined): boolean {
    return proto3.util.equals(Product, a, b);
  }
}

/**
 * Order represents a customer order.
 *
 * @generated from message mw.common.Order
 */
export class Order extends Message<Order> {
  /**
   * Internal GUID.
   *
   * @generated from field: string id = 1;
   */
  id = "";

  /**
   * @generated from field: mw.common.Customer customer = 2;
   */
  customer?: Customer;

  /**
   * @generated from field: mw.common.OrderStatus status = 3;
   */
  status = OrderStatus.INVALID;

  /**
   * SAP order number (assigned after processing).
   *
   * @generated from field: uint64 sap_id = 4;
   */
  sapId = protoInt64.zero;

  /**
   * Timestamps (ISO 8601).
   *
   * @generated from field: string created_at = 5;
   */
  createdAt = "";

  /**
   * @generated from field: string updated_at = 6;
   */
  updatedAt = "";

  /**
   * @generated from field: string processed_at = 7;
   */
  processedAt = "";

  /**
   * @generated from field: string shipped_at = 8;
   */
  shippedAt = "";

  /**
   * @generated from field: mw.common.OrderSummary order_summary = 9;
   */
  orderSummary?: OrderSummary;

  /**
   * Whether an invoice PDF has been generated.
   *
   * @generated from field: bool has_invoice = 10;
   */
  hasInvoice = false;

  /**
   * Customer note / special instructions.
   *
   * @generated from field: string note = 11;
   */
  note = "";

  /**
   * Invoice address (flattened for historical orders).
   *
   * @generated from field: string email = 12;
   */
  email = "";

  /**
   * @generated from field: string name1 = 13;
   */
  name1 = "";

  /**
   * @generated from field: string name2 = 14;
   */
  name2 = "";

  /**
   * @generated from field: string street = 15;
   */
  street = "";

  /**
   * @generated from field: string zip = 16;
   */
  zip = "";

  /**
   * @generated from field: string city = 17;
   */
  city = "";

  /**
   * @generated from field: string country = 18;
   */
  country = "";

  /**
   * Separate delivery address (if different from invoice).
   *
   * @generated from field: mw.common.Address delivery_address = 19;
   */
  deliveryAddress?: Address;

  /**
   * @generated from field: mw.common.OrderType order_type = 20;
   */
  orderType = OrderType.INVALID;

  /**
   * @generated from field: mw.common.PaymentType payment_type = 21;
   */
  paymentType = PaymentType.INVALID;

  constructor(data?: PartialMessage<Order>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "mw.common.Order";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "customer", kind: "message", T: Customer },
    { no: 3, name: "status", kind: "enum", T: proto3.getEnumType(OrderStatus) },
    { no: 4, name: "sap_id", kind: "scalar", T: 4 /* ScalarType.UINT64 */ },
    { no: 5, name: "created_at", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 6, name: "updated_at", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 7, name: "processed_at", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 8, name: "shipped_at", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 9, name: "order_summary", kind: "message", T: OrderSummary },
    { no: 10, name: "has_invoice", kind: "scalar", T: 8 /* ScalarType.BOOL */ },
    { no: 11, name: "note", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 12, name: "email", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 13, name: "name1", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 14, name: "name2", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 15, name: "street", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 16, name: "zip", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 17, name: "city", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 18, name: "country", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 19, name: "delivery_address", kind: "message", T: Address },
    { no: 20, name: "order_type", kind: "enum", T: proto3.getEnumType(OrderType) },
    { no: 21, name: "payment_type", kind: "enum", T: proto3.getEnumType(PaymentType) },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): Order {
    return new Order().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): Order {
    return new Order().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): Order {
    return new Order().fromJsonString(jsonString, options);
  }

  static equals(a: Order | PlainMessage<Order> | undefined, b: Order | PlainMessage<Order> | undefined): boolean {
    return proto3.util.equals(Order, a, b);
  }
}

/**
 * OrderSummary contains calculated totals for an order or cart.
 *
 * @generated from message mw.common.OrderSummary
 */
export class OrderSummary extends Message<OrderSummary> {
  /**
   * @generated from field: repeated mw.common.OrderProduct order_products = 1;
   */
  orderProducts: OrderProduct[] = [];

  /**
   * Formatted price strings (e.g. "123,45 EUR").
   *
   * @generated from field: string total_price_b2b = 2;
   */
  totalPriceB2b = "";

  /**
   * @generated from field: string total_price_b2c = 3;
   */
  totalPriceB2c = "";

  /**
   * @generated from field: int32 total_quantity = 4;
   */
  totalQuantity = 0;

  /**
   * @generated from field: string shipping_costs = 5;
   */
  shippingCosts = "";

  /**
   * @generated from field: string vat = 6;
   */
  vat = "";

  /**
   * Surcharge applied when order is below minimum quantity.
   *
   * @generated from field: string minimum_quantity_surcharge = 7;
   */
  minimumQuantitySurcharge = "";

  /**
   * Discount for online ordering (3% B2B, 10% student).
   *
   * @generated from field: string online_discount = 8;
   */
  onlineDiscount = "";

  /**
   * Final total including VAT, shipping, discounts.
   *
   * @generated from field: string total_price = 9;
   */
  totalPrice = "";

  /**
   * @generated from field: string vat_percentage = 10;
   */
  vatPercentage = "";

  /**
   * Whether the order contains any special offer products.
   *
   * @generated from field: bool contains_special_offer = 11;
   */
  containsSpecialOffer = false;

  constructor(data?: PartialMessage<OrderSummary>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "mw.common.OrderSummary";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "order_products", kind: "message", T: OrderProduct, repeated: true },
    { no: 2, name: "total_price_b2b", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 3, name: "total_price_b2c", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 4, name: "total_quantity", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
    { no: 5, name: "shipping_costs", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 6, name: "vat", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 7, name: "minimum_quantity_surcharge", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 8, name: "online_discount", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 9, name: "total_price", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 10, name: "vat_percentage", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 11, name: "contains_special_offer", kind: "scalar", T: 8 /* ScalarType.BOOL */ },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): OrderSummary {
    return new OrderSummary().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): OrderSummary {
    return new OrderSummary().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): OrderSummary {
    return new OrderSummary().fromJsonString(jsonString, options);
  }

  static equals(a: OrderSummary | PlainMessage<OrderSummary> | undefined, b: OrderSummary | PlainMessage<OrderSummary> | undefined): boolean {
    return proto3.util.equals(OrderSummary, a, b);
  }
}

/**
 * OrderProduct is a line item within an order.
 *
 * @generated from message mw.common.OrderProduct
 */
export class OrderProduct extends Message<OrderProduct> {
  /**
   * Internal GUID.
   *
   * @generated from field: string id = 1;
   */
  id = "";

  /**
   * @generated from field: int32 quantity = 2;
   */
  quantity = 0;

  /**
   * @generated from field: string ean = 3;
   */
  ean = "";

  /**
   * @generated from field: string model_number = 4;
   */
  modelNumber = "";

  /**
   * @generated from field: string name_de = 5;
   */
  nameDe = "";

  /**
   * @generated from field: string name_en = 6;
   */
  nameEn = "";

  /**
   * @generated from field: float price_b2b = 7;
   */
  priceB2b = 0;

  /**
   * @generated from field: float price_b2c = 8;
   */
  priceB2c = 0;

  /**
   * @generated from field: float quantity_per_pack = 9;
   */
  quantityPerPack = 0;

  /**
   * @generated from field: string quantity_unit_key = 10;
   */
  quantityUnitKey = "";

  /**
   * @generated from field: string quantity_unit_name = 11;
   */
  quantityUnitName = "";

  /**
   * @generated from field: string product_line_key = 12;
   */
  productLineKey = "";

  /**
   * @generated from field: string product_line_name = 13;
   */
  productLineName = "";

  /**
   * @generated from field: string variant_name = 14;
   */
  variantName = "";

  /**
   * @generated from field: string variant_number = 15;
   */
  variantNumber = "";

  /**
   * @generated from field: string product_category_name = 16;
   */
  productCategoryName = "";

  /**
   * GUID of the referenced Product.
   *
   * @generated from field: string product_id = 17;
   */
  productId = "";

  /**
   * @generated from field: uint32 minimal_order_quantity = 18;
   */
  minimalOrderQuantity = 0;

  /**
   * @generated from field: string google_id = 19;
   */
  googleId = "";

  /**
   * @generated from field: string product_group = 20;
   */
  productGroup = "";

  /**
   * Special offer applied to this line item.
   *
   * @generated from field: mw.common.SpecialOffer special_offer = 21;
   */
  specialOffer?: SpecialOffer;

  /**
   * True when the line item is currently orderable.
   * False means the customer can see it in the cart but it is excluded from
   * totals and not transmitted on submit (e.g. stock dropped after add to cart).
   *
   * @generated from field: bool is_available = 22;
   */
  isAvailable = false;

  /**
   * Free-form reason code populated when is_available is false.
   * See database.AvailabilityReason for the canonical values
   * (out_of_stock, blocked, no_price, no_permission, ...).
   *
   * @generated from field: string availability_reason = 23;
   */
  availabilityReason = "";

  constructor(data?: PartialMessage<OrderProduct>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "mw.common.OrderProduct";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "quantity", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
    { no: 3, name: "ean", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 4, name: "model_number", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 5, name: "name_de", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 6, name: "name_en", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 7, name: "price_b2b", kind: "scalar", T: 2 /* ScalarType.FLOAT */ },
    { no: 8, name: "price_b2c", kind: "scalar", T: 2 /* ScalarType.FLOAT */ },
    { no: 9, name: "quantity_per_pack", kind: "scalar", T: 2 /* ScalarType.FLOAT */ },
    { no: 10, name: "quantity_unit_key", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 11, name: "quantity_unit_name", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 12, name: "product_line_key", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 13, name: "product_line_name", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 14, name: "variant_name", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 15, name: "variant_number", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 16, name: "product_category_name", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 17, name: "product_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 18, name: "minimal_order_quantity", kind: "scalar", T: 13 /* ScalarType.UINT32 */ },
    { no: 19, name: "google_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 20, name: "product_group", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 21, name: "special_offer", kind: "message", T: SpecialOffer },
    { no: 22, name: "is_available", kind: "scalar", T: 8 /* ScalarType.BOOL */ },
    { no: 23, name: "availability_reason", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): OrderProduct {
    return new OrderProduct().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): OrderProduct {
    return new OrderProduct().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): OrderProduct {
    return new OrderProduct().fromJsonString(jsonString, options);
  }

  static equals(a: OrderProduct | PlainMessage<OrderProduct> | undefined, b: OrderProduct | PlainMessage<OrderProduct> | undefined): boolean {
    return proto3.util.equals(OrderProduct, a, b);
  }
}

/**
 * SpecialOffer wraps a product with promotional pricing and conditions.
 *
 * @generated from message mw.common.SpecialOffer
 */
export class SpecialOffer extends Message<SpecialOffer> {
  /**
   * Internal GUID.
   *
   * @generated from field: string id = 1;
   */
  id = "";

  /**
   * The product being offered at a special price. Hidden from regular order form.
   *
   * @generated from field: mw.common.Product product = 2;
   */
  product?: Product;

  /**
   * @generated from field: mw.common.SpecialOfferType type = 3;
   */
  type = SpecialOfferType.INVALID;

  /**
   * Validity period (ISO 8601 date strings).
   *
   * @generated from field: string valid_from = 4;
   */
  validFrom = "";

  /**
   * @generated from field: string valid_until = 5;
   */
  validUntil = "";

  /**
   * If true, the entire order ships free when this offer is in the cart.
   *
   * @generated from field: bool removes_shipping_costs = 6;
   */
  removesShippingCosts = false;

  /**
   * Whether the standard online discount applies on top of the special price.
   *
   * @generated from field: bool online_discount_applicable = 7;
   */
  onlineDiscountApplicable = false;

  /**
   * Maximum quantity a single customer can order (across all their orders).
   *
   * @generated from field: int32 max_quantity_per_customer = 8;
   */
  maxQuantityPerCustomer = 0;

  /**
   * If true, only visible to the test customer (for staging/QA).
   *
   * @generated from field: bool test_mode = 9;
   */
  testMode = false;

  /**
   * Customer category visibility flags.
   *
   * @generated from field: bool deco_customer_applicable = 10;
   */
  decoCustomerApplicable = false;

  /**
   * @generated from field: bool care_customer_applicable = 11;
   */
  careCustomerApplicable = false;

  /**
   * Marketing description shown to the customer.
   *
   * @generated from field: string description = 12;
   */
  description = "";

  /**
   * Total number of times this offer has been used.
   *
   * @generated from field: int32 usages = 13;
   */
  usages = 0;

  /**
   * Menu tile image (shown in the offers navigation).
   *
   * @generated from field: mw.common.Image menu_image = 14;
   */
  menuImage?: Image;

  /**
   * Shop detail image (shown on the offer detail page).
   *
   * @generated from field: mw.common.Image shop_image = 15;
   */
  shopImage?: Image;

  /**
   * @generated from field: string created_at = 16;
   */
  createdAt = "";

  /**
   * @generated from field: string updated_at = 17;
   */
  updatedAt = "";

  /**
   * HTML content for an info box displayed with the offer.
   *
   * @generated from field: string info_box = 18;
   */
  infoBox = "";

  constructor(data?: PartialMessage<SpecialOffer>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "mw.common.SpecialOffer";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "product", kind: "message", T: Product },
    { no: 3, name: "type", kind: "enum", T: proto3.getEnumType(SpecialOfferType) },
    { no: 4, name: "valid_from", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 5, name: "valid_until", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 6, name: "removes_shipping_costs", kind: "scalar", T: 8 /* ScalarType.BOOL */ },
    { no: 7, name: "online_discount_applicable", kind: "scalar", T: 8 /* ScalarType.BOOL */ },
    { no: 8, name: "max_quantity_per_customer", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
    { no: 9, name: "test_mode", kind: "scalar", T: 8 /* ScalarType.BOOL */ },
    { no: 10, name: "deco_customer_applicable", kind: "scalar", T: 8 /* ScalarType.BOOL */ },
    { no: 11, name: "care_customer_applicable", kind: "scalar", T: 8 /* ScalarType.BOOL */ },
    { no: 12, name: "description", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 13, name: "usages", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
    { no: 14, name: "menu_image", kind: "message", T: Image },
    { no: 15, name: "shop_image", kind: "message", T: Image },
    { no: 16, name: "created_at", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 17, name: "updated_at", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 18, name: "info_box", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): SpecialOffer {
    return new SpecialOffer().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): SpecialOffer {
    return new SpecialOffer().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): SpecialOffer {
    return new SpecialOffer().fromJsonString(jsonString, options);
  }

  static equals(a: SpecialOffer | PlainMessage<SpecialOffer> | undefined, b: SpecialOffer | PlainMessage<SpecialOffer> | undefined): boolean {
    return proto3.util.equals(SpecialOffer, a, b);
  }
}

/**
 * Image stores metadata and optionally binary data for uploaded images.
 *
 * @generated from message mw.common.Image
 */
export class Image extends Message<Image> {
  /**
   * Internal GUID.
   *
   * @generated from field: string id = 1;
   */
  id = "";

  /**
   * FK to SpecialOffer (if this image belongs to an offer).
   *
   * @generated from field: string special_offer_id = 2;
   */
  specialOfferId = "";

  /**
   * FK to Product (if this image belongs to a product).
   *
   * @generated from field: string product_id = 3;
   */
  productId = "";

  /**
   * @generated from field: mw.common.ImageType image_type = 4;
   */
  imageType = ImageType.INVALID;

  /**
   * Original filename.
   *
   * @generated from field: string name = 5;
   */
  name = "";

  /**
   * File extension (e.g. "jpg", "png").
   *
   * @generated from field: string file_type = 6;
   */
  fileType = "";

  /**
   * MIME type (e.g. "image/jpeg").
   *
   * @generated from field: string mime_type = 7;
   */
  mimeType = "";

  /**
   * File size in bytes.
   *
   * @generated from field: int32 size = 8;
   */
  size = 0;

  /**
   * @generated from field: int32 height = 9;
   */
  height = 0;

  /**
   * @generated from field: int32 width = 10;
   */
  width = 0;

  /**
   * S3 ETag for cache invalidation.
   *
   * @generated from field: string etag = 11;
   */
  etag = "";

  /**
   * Canonical URL path.
   *
   * @generated from field: string canonical = 12;
   */
  canonical = "";

  /**
   * Full public URL.
   *
   * @generated from field: string url = 13;
   */
  url = "";

  /**
   * Raw binary data (for upload/download).
   *
   * @generated from field: bytes data = 14;
   */
  data = new Uint8Array(0);

  /**
   * @generated from field: string created_at = 15;
   */
  createdAt = "";

  /**
   * @generated from field: string updated_at = 16;
   */
  updatedAt = "";

  /**
   * @generated from field: string deleted_at = 17;
   */
  deletedAt = "";

  constructor(data?: PartialMessage<Image>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "mw.common.Image";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "special_offer_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 3, name: "product_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 4, name: "image_type", kind: "enum", T: proto3.getEnumType(ImageType) },
    { no: 5, name: "name", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 6, name: "file_type", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 7, name: "mime_type", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 8, name: "size", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
    { no: 9, name: "height", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
    { no: 10, name: "width", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
    { no: 11, name: "etag", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 12, name: "canonical", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 13, name: "url", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 14, name: "data", kind: "scalar", T: 12 /* ScalarType.BYTES */ },
    { no: 15, name: "created_at", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 16, name: "updated_at", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 17, name: "deleted_at", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): Image {
    return new Image().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): Image {
    return new Image().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): Image {
    return new Image().fromJsonString(jsonString, options);
  }

  static equals(a: Image | PlainMessage<Image> | undefined, b: Image | PlainMessage<Image> | undefined): boolean {
    return proto3.util.equals(Image, a, b);
  }
}

/**
 * MiniShop is a standalone storefront for prospect customers who are not yet
 * in SAP. Orders go through PayPal and use a collective SAP customer ID.
 *
 * @generated from message mw.common.MiniShop
 */
export class MiniShop extends Message<MiniShop> {
  /**
   * Internal GUID.
   *
   * @generated from field: string id = 1;
   */
  id = "";

  /**
   * URL-safe shop identifier (used in the shop URL).
   *
   * @generated from field: string name = 2;
   */
  name = "";

  /**
   * Whether the shop is publicly accessible.
   *
   * @generated from field: bool active = 3;
   */
  active = false;

  /**
   * Description shown on the PayPal checkout page.
   *
   * @generated from field: string paypal_description = 6;
   */
  paypalDescription = "";

  /**
   * @generated from field: string created_at = 7;
   */
  createdAt = "";

  /**
   * @generated from field: string updated_at = 8;
   */
  updatedAt = "";

  /**
   * @generated from field: string deleted_at = 9;
   */
  deletedAt = "";

  /**
   * Products available in this mini shop (as special offers).
   *
   * @generated from field: repeated mw.common.SpecialOffer special_offers = 10;
   */
  specialOffers: SpecialOffer[] = [];

  constructor(data?: PartialMessage<MiniShop>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "mw.common.MiniShop";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "name", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 3, name: "active", kind: "scalar", T: 8 /* ScalarType.BOOL */ },
    { no: 6, name: "paypal_description", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 7, name: "created_at", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 8, name: "updated_at", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 9, name: "deleted_at", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 10, name: "special_offers", kind: "message", T: SpecialOffer, repeated: true },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): MiniShop {
    return new MiniShop().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): MiniShop {
    return new MiniShop().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): MiniShop {
    return new MiniShop().fromJsonString(jsonString, options);
  }

  static equals(a: MiniShop | PlainMessage<MiniShop> | undefined, b: MiniShop | PlainMessage<MiniShop> | undefined): boolean {
    return proto3.util.equals(MiniShop, a, b);
  }
}

/**
 * Usage tracks a single analytics event for mini shop visits and conversions.
 *
 * @generated from message mw.common.Usage
 */
export class Usage extends Message<Usage> {
  /**
   * Anonymous visitor identifier (GUID, stored in cookie).
   *
   * @generated from field: string visitor_guid = 1;
   */
  visitorGuid = "";

  /**
   * FK to MiniShop.
   *
   * @generated from field: string mini_shop_id = 2;
   */
  miniShopId = "";

  /**
   * FK to Order (if an order was created).
   *
   * @generated from field: string order_shop_id = 3;
   */
  orderShopId = "";

  /**
   * HTTP referrer URL.
   *
   * @generated from field: string referrer = 4;
   */
  referrer = "";

  /**
   * @generated from field: mw.common.UsageType event = 5;
   */
  event = UsageType.INVALID;

  /**
   * Raw User-Agent string.
   *
   * @generated from field: string agent = 6;
   */
  agent = "";

  /**
   * 1 if visited via QR code.
   *
   * @generated from field: int32 qr = 7;
   */
  qr = 0;

  /**
   * Additional event details (JSON string).
   *
   * @generated from field: string details = 8;
   */
  details = "";

  /**
   * Device detection flags (1 = detected).
   *
   * @generated from field: int32 mobile = 9;
   */
  mobile = 0;

  /**
   * @generated from field: int32 tablet = 10;
   */
  tablet = 0;

  /**
   * @generated from field: int32 desktop = 11;
   */
  desktop = 0;

  /**
   * @generated from field: int32 android = 12;
   */
  android = 0;

  /**
   * @generated from field: int32 ios = 13;
   */
  ios = 0;

  /**
   * @generated from field: int32 mac = 14;
   */
  mac = 0;

  /**
   * @generated from field: int32 windows = 15;
   */
  windows = 0;

  /**
   * @generated from field: int32 bot = 16;
   */
  bot = 0;

  /**
   * @generated from field: string created_at = 17;
   */
  createdAt = "";

  /**
   * @generated from field: string updated_at = 18;
   */
  updatedAt = "";

  /**
   * @generated from field: string deleted_at = 19;
   */
  deletedAt = "";

  /**
   * Campaign tracking parameters.
   *
   * @generated from field: string gclid = 20;
   */
  gclid = "";

  /**
   * @generated from field: string fbclid = 21;
   */
  fbclid = "";

  constructor(data?: PartialMessage<Usage>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "mw.common.Usage";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "visitor_guid", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "mini_shop_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 3, name: "order_shop_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 4, name: "referrer", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 5, name: "event", kind: "enum", T: proto3.getEnumType(UsageType) },
    { no: 6, name: "agent", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 7, name: "qr", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
    { no: 8, name: "details", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 9, name: "mobile", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
    { no: 10, name: "tablet", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
    { no: 11, name: "desktop", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
    { no: 12, name: "android", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
    { no: 13, name: "ios", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
    { no: 14, name: "mac", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
    { no: 15, name: "windows", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
    { no: 16, name: "bot", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
    { no: 17, name: "created_at", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 18, name: "updated_at", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 19, name: "deleted_at", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 20, name: "gclid", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 21, name: "fbclid", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): Usage {
    return new Usage().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): Usage {
    return new Usage().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): Usage {
    return new Usage().fromJsonString(jsonString, options);
  }

  static equals(a: Usage | PlainMessage<Usage> | undefined, b: Usage | PlainMessage<Usage> | undefined): boolean {
    return proto3.util.equals(Usage, a, b);
  }
}

/**
 * UsageSummary aggregates usage data for admin dashboard reports.
 *
 * @generated from message mw.common.UsageSummary
 */
export class UsageSummary extends Message<UsageSummary> {
  /**
   * Report period (ISO 8601 date strings).
   *
   * @generated from field: string start_date = 1;
   */
  startDate = "";

  /**
   * @generated from field: string end_date = 2;
   */
  endDate = "";

  /**
   * @generated from field: mw.common.UsageType event = 3;
   */
  event = UsageType.INVALID;

  /**
   * @generated from field: string referrer = 4;
   */
  referrer = "";

  /**
   * Total event count.
   *
   * @generated from field: int32 count = 5;
   */
  count = 0;

  /**
   * Orders resulting from these visits.
   *
   * @generated from field: int32 order_count = 6;
   */
  orderCount = 0;

  /**
   * Device/platform breakdowns (percentages, 0-100).
   *
   * @generated from field: int32 qr_percentage = 7;
   */
  qrPercentage = 0;

  /**
   * @generated from field: int32 mobile_percentage = 8;
   */
  mobilePercentage = 0;

  /**
   * @generated from field: int32 tablet_percentage = 9;
   */
  tabletPercentage = 0;

  /**
   * @generated from field: int32 desktop_percentage = 10;
   */
  desktopPercentage = 0;

  /**
   * @generated from field: int32 android_percentage = 11;
   */
  androidPercentage = 0;

  /**
   * @generated from field: int32 ios_percentage = 12;
   */
  iosPercentage = 0;

  /**
   * @generated from field: int32 mac_percentage = 13;
   */
  macPercentage = 0;

  /**
   * @generated from field: int32 windows_percentage = 14;
   */
  windowsPercentage = 0;

  /**
   * @generated from field: int32 bot_percentage = 15;
   */
  botPercentage = 0;

  /**
   * Total revenue from resulting orders (formatted string).
   *
   * @generated from field: string revenue = 16;
   */
  revenue = "";

  constructor(data?: PartialMessage<UsageSummary>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "mw.common.UsageSummary";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "start_date", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "end_date", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 3, name: "event", kind: "enum", T: proto3.getEnumType(UsageType) },
    { no: 4, name: "referrer", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 5, name: "count", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
    { no: 6, name: "order_count", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
    { no: 7, name: "qr_percentage", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
    { no: 8, name: "mobile_percentage", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
    { no: 9, name: "tablet_percentage", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
    { no: 10, name: "desktop_percentage", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
    { no: 11, name: "android_percentage", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
    { no: 12, name: "ios_percentage", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
    { no: 13, name: "mac_percentage", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
    { no: 14, name: "windows_percentage", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
    { no: 15, name: "bot_percentage", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
    { no: 16, name: "revenue", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): UsageSummary {
    return new UsageSummary().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): UsageSummary {
    return new UsageSummary().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): UsageSummary {
    return new UsageSummary().fromJsonString(jsonString, options);
  }

  static equals(a: UsageSummary | PlainMessage<UsageSummary> | undefined, b: UsageSummary | PlainMessage<UsageSummary> | undefined): boolean {
    return proto3.util.equals(UsageSummary, a, b);
  }
}

/**
 * OrderForm is the top-level container for the legacy order form layout.
 *
 * @generated from message mw.common.OrderForm
 */
export class OrderForm extends Message<OrderForm> {
  /**
   * Sections grouped by main category (Care, Deco, etc.).
   *
   * @generated from field: repeated mw.common.OrderFormCategory main_categories = 1;
   */
  mainCategories: OrderFormCategory[] = [];

  /**
   * Live-calculated order summary.
   *
   * @generated from field: mw.common.OrderSummary summary = 2;
   */
  summary?: OrderSummary;

  constructor(data?: PartialMessage<OrderForm>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "mw.common.OrderForm";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "main_categories", kind: "message", T: OrderFormCategory, repeated: true },
    { no: 2, name: "summary", kind: "message", T: OrderSummary },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): OrderForm {
    return new OrderForm().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): OrderForm {
    return new OrderForm().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): OrderForm {
    return new OrderForm().fromJsonString(jsonString, options);
  }

  static equals(a: OrderForm | PlainMessage<OrderForm> | undefined, b: OrderForm | PlainMessage<OrderForm> | undefined): boolean {
    return proto3.util.equals(OrderForm, a, b);
  }
}

/**
 * OrderFormCategory groups product lines under a main category header.
 *
 * @generated from message mw.common.OrderFormCategory
 */
export class OrderFormCategory extends Message<OrderFormCategory> {
  /**
   * @generated from field: string category_id = 1;
   */
  categoryId = "";

  /**
   * Display title (e.g. "Deco", "Care").
   *
   * @generated from field: string title = 2;
   */
  title = "";

  /**
   * Product groups within this category.
   *
   * @generated from field: repeated mw.common.OrderFormProductGroup product_groups = 3;
   */
  productGroups: OrderFormProductGroup[] = [];

  constructor(data?: PartialMessage<OrderFormCategory>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "mw.common.OrderFormCategory";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "category_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "title", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 3, name: "product_groups", kind: "message", T: OrderFormProductGroup, repeated: true },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): OrderFormCategory {
    return new OrderFormCategory().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): OrderFormCategory {
    return new OrderFormCategory().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): OrderFormCategory {
    return new OrderFormCategory().fromJsonString(jsonString, options);
  }

  static equals(a: OrderFormCategory | PlainMessage<OrderFormCategory> | undefined, b: OrderFormCategory | PlainMessage<OrderFormCategory> | undefined): boolean {
    return proto3.util.equals(OrderFormCategory, a, b);
  }
}

/**
 * OrderFormProductGroup groups product lines by their product line
 * (e.g. "Nail Lacquer", "Cleansing").
 *
 * @generated from message mw.common.OrderFormProductGroup
 */
export class OrderFormProductGroup extends Message<OrderFormProductGroup> {
  /**
   * Product line name.
   *
   * @generated from field: string title = 1;
   */
  title = "";

  /**
   * Individual product lines (e.g. multiple color ranges).
   *
   * @generated from field: repeated mw.common.OrderFormProductLine product_lines = 2;
   */
  productLines: OrderFormProductLine[] = [];

  /**
   * @generated from field: bool contains_special_offer = 3;
   */
  containsSpecialOffer = false;

  constructor(data?: PartialMessage<OrderFormProductGroup>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "mw.common.OrderFormProductGroup";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "title", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "product_lines", kind: "message", T: OrderFormProductLine, repeated: true },
    { no: 3, name: "contains_special_offer", kind: "scalar", T: 8 /* ScalarType.BOOL */ },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): OrderFormProductGroup {
    return new OrderFormProductGroup().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): OrderFormProductGroup {
    return new OrderFormProductGroup().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): OrderFormProductGroup {
    return new OrderFormProductGroup().fromJsonString(jsonString, options);
  }

  static equals(a: OrderFormProductGroup | PlainMessage<OrderFormProductGroup> | undefined, b: OrderFormProductGroup | PlainMessage<OrderFormProductGroup> | undefined): boolean {
    return proto3.util.equals(OrderFormProductGroup, a, b);
  }
}

/**
 * OrderFormProductLine represents a row in the order form for a specific product line
 * with columns for variants (colors/sizes).
 *
 * @generated from message mw.common.OrderFormProductLine
 */
export class OrderFormProductLine extends Message<OrderFormProductLine> {
  /**
   * Line title (e.g. "459.XX High Cover Foundation").
   *
   * @generated from field: string title = 1;
   */
  title = "";

  /**
   * Variant numbers displayed as column headers (e.g. "23", "45").
   * Must be strings as values may contain letters.
   *
   * @generated from field: repeated string color_numbers = 2;
   */
  colorNumbers: string[] = [];

  /**
   * Model number pattern (e.g. "40.XX" where XX is the variant).
   *
   * @generated from field: string model_number_pattern = 3;
   */
  modelNumberPattern = "";

  /**
   * @generated from field: string price_b2b = 4;
   */
  priceB2b = "";

  /**
   * @generated from field: string price_b2c = 5;
   */
  priceB2c = "";

  /**
   * Product rows by type. Suffix rules for model numbers:
   * - Main: regular products (no special suffix)
   * - Tester A: XX80 or .80 suffix
   * - Tester B: XX81 or .81 suffix (or XX83/.83)
   * - Sachet: XX83 or .83 suffix (sample packets)
   * - Practice: XX85 or .85 suffix (training products)
   * - Special: promotional or limited edition
   *
   * @generated from field: mw.common.OrderFormProductRow product_row_main = 6;
   */
  productRowMain?: OrderFormProductRow;

  /**
   * @generated from field: mw.common.OrderFormProductRow product_row_tester_a = 7;
   */
  productRowTesterA?: OrderFormProductRow;

  /**
   * @generated from field: mw.common.OrderFormProductRow product_row_tester_b = 8;
   */
  productRowTesterB?: OrderFormProductRow;

  /**
   * @generated from field: mw.common.OrderFormProductRow product_row_sachet = 9;
   */
  productRowSachet?: OrderFormProductRow;

  /**
   * @generated from field: mw.common.OrderFormProductRow product_row_practice = 10;
   */
  productRowPractice?: OrderFormProductRow;

  /**
   * @generated from field: mw.common.OrderFormProductRow product_row_special = 11;
   */
  productRowSpecial?: OrderFormProductRow;

  /**
   * @generated from field: mw.common.MainCategory main_category = 12;
   */
  mainCategory = MainCategory.INVALID;

  /**
   * Label for the variant axis (e.g. "Farbnummer", "Variante").
   *
   * @generated from field: string variant_type_label = 13;
   */
  variantTypeLabel = "";

  /**
   * @generated from field: bool contains_special_offer = 14;
   */
  containsSpecialOffer = false;

  /**
   * @generated from field: bool contains_refill_products = 15;
   */
  containsRefillProducts = false;

  constructor(data?: PartialMessage<OrderFormProductLine>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "mw.common.OrderFormProductLine";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "title", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "color_numbers", kind: "scalar", T: 9 /* ScalarType.STRING */, repeated: true },
    { no: 3, name: "model_number_pattern", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 4, name: "price_b2b", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 5, name: "price_b2c", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 6, name: "product_row_main", kind: "message", T: OrderFormProductRow },
    { no: 7, name: "product_row_tester_a", kind: "message", T: OrderFormProductRow },
    { no: 8, name: "product_row_tester_b", kind: "message", T: OrderFormProductRow },
    { no: 9, name: "product_row_sachet", kind: "message", T: OrderFormProductRow },
    { no: 10, name: "product_row_practice", kind: "message", T: OrderFormProductRow },
    { no: 11, name: "product_row_special", kind: "message", T: OrderFormProductRow },
    { no: 12, name: "main_category", kind: "enum", T: proto3.getEnumType(MainCategory) },
    { no: 13, name: "variant_type_label", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 14, name: "contains_special_offer", kind: "scalar", T: 8 /* ScalarType.BOOL */ },
    { no: 15, name: "contains_refill_products", kind: "scalar", T: 8 /* ScalarType.BOOL */ },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): OrderFormProductLine {
    return new OrderFormProductLine().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): OrderFormProductLine {
    return new OrderFormProductLine().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): OrderFormProductLine {
    return new OrderFormProductLine().fromJsonString(jsonString, options);
  }

  static equals(a: OrderFormProductLine | PlainMessage<OrderFormProductLine> | undefined, b: OrderFormProductLine | PlainMessage<OrderFormProductLine> | undefined): boolean {
    return proto3.util.equals(OrderFormProductLine, a, b);
  }
}

/**
 * OrderFormProductRow is a horizontal row (e.g. "Tester A") with cells per variant.
 *
 * @generated from message mw.common.OrderFormProductRow
 */
export class OrderFormProductRow extends Message<OrderFormProductRow> {
  /**
   * Row label (e.g. "40.10080 Tester").
   *
   * @generated from field: string title = 1;
   */
  title = "";

  /**
   * One cell per variant column.
   *
   * @generated from field: repeated mw.common.OrderFormProductCell product_cell = 2;
   */
  productCell: OrderFormProductCell[] = [];

  /**
   * @generated from field: string price_b2b = 3;
   */
  priceB2b = "";

  /**
   * @generated from field: bool contains_special_offer = 4;
   */
  containsSpecialOffer = false;

  constructor(data?: PartialMessage<OrderFormProductRow>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "mw.common.OrderFormProductRow";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "title", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "product_cell", kind: "message", T: OrderFormProductCell, repeated: true },
    { no: 3, name: "price_b2b", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 4, name: "contains_special_offer", kind: "scalar", T: 8 /* ScalarType.BOOL */ },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): OrderFormProductRow {
    return new OrderFormProductRow().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): OrderFormProductRow {
    return new OrderFormProductRow().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): OrderFormProductRow {
    return new OrderFormProductRow().fromJsonString(jsonString, options);
  }

  static equals(a: OrderFormProductRow | PlainMessage<OrderFormProductRow> | undefined, b: OrderFormProductRow | PlainMessage<OrderFormProductRow> | undefined): boolean {
    return proto3.util.equals(OrderFormProductRow, a, b);
  }
}

/**
 * OrderFormProductCell is a single orderable cell in the legacy order form grid.
 *
 * @generated from message mw.common.OrderFormProductCell
 */
export class OrderFormProductCell extends Message<OrderFormProductCell> {
  /**
   * @generated from field: mw.common.Product product = 1;
   */
  product?: Product;

  /**
   * Availability status.
   *
   * @generated from field: string status = 2;
   */
  status = "";

  /**
   * Selected order quantity.
   *
   * @generated from field: uint32 quantity = 3;
   */
  quantity = 0;

  /**
   * Whether this cell has a special price applied.
   *
   * @generated from field: bool special_price = 4;
   */
  specialPrice = false;

  /**
   * Product lifecycle flags.
   *
   * @generated from field: bool new_product = 5;
   */
  newProduct = false;

  /**
   * @generated from field: bool expiring_product = 6;
   */
  expiringProduct = false;

  /**
   * The variant number for this cell's column.
   *
   * @generated from field: string color_number = 7;
   */
  colorNumber = "";

  /**
   * @generated from field: bool contains_special_offer = 8;
   */
  containsSpecialOffer = false;

  constructor(data?: PartialMessage<OrderFormProductCell>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "mw.common.OrderFormProductCell";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "product", kind: "message", T: Product },
    { no: 2, name: "status", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 3, name: "quantity", kind: "scalar", T: 13 /* ScalarType.UINT32 */ },
    { no: 4, name: "special_price", kind: "scalar", T: 8 /* ScalarType.BOOL */ },
    { no: 5, name: "new_product", kind: "scalar", T: 8 /* ScalarType.BOOL */ },
    { no: 6, name: "expiring_product", kind: "scalar", T: 8 /* ScalarType.BOOL */ },
    { no: 7, name: "color_number", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 8, name: "contains_special_offer", kind: "scalar", T: 8 /* ScalarType.BOOL */ },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): OrderFormProductCell {
    return new OrderFormProductCell().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): OrderFormProductCell {
    return new OrderFormProductCell().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): OrderFormProductCell {
    return new OrderFormProductCell().fromJsonString(jsonString, options);
  }

  static equals(a: OrderFormProductCell | PlainMessage<OrderFormProductCell> | undefined, b: OrderFormProductCell | PlainMessage<OrderFormProductCell> | undefined): boolean {
    return proto3.util.equals(OrderFormProductCell, a, b);
  }
}

/**
 * OrderFormProduct defines how a product appears in the V2 order form.
 * This is an admin-managed mapping between SAP products and order form layout.
 *
 * @generated from message mw.common.OrderFormProduct
 */
export class OrderFormProduct extends Message<OrderFormProduct> {
  /**
   * @generated from field: uint64 id = 1;
   */
  id = protoInt64.zero;

  /**
   * FK to Product (SAP product ID in our DB).
   *
   * @generated from field: uint64 product_id = 2;
   */
  productId = protoInt64.zero;

  /**
   * Populated product data (in responses).
   *
   * @generated from field: mw.common.Product product = 3;
   */
  product?: Product;

  /**
   * Which order form this belongs to (e.g. "b2b", "student").
   *
   * @generated from field: string order_form = 4;
   */
  orderForm = "";

  /**
   * Visibility status.
   *
   * @generated from field: mw.common.OrderFormProductStatus status = 5;
   */
  status = OrderFormProductStatus.INVALID;

  /**
   * Category grouping within the order form.
   *
   * @generated from field: string category = 6;
   */
  category = "";

  /**
   * Product line number (e.g. "40") and name for grouping.
   *
   * @generated from field: string product_line_number = 7;
   */
  productLineNumber = "";

  /**
   * @generated from field: string product_line_name = 8;
   */
  productLineName = "";

  /**
   * Whether this product defines the price displayed for its product line.
   *
   * @generated from field: bool product_line_price_definer = 9;
   */
  productLinePriceDefiner = false;

  /**
   * Column header (e.g. color number "23").
   *
   * @generated from field: string column_name = 10;
   */
  columnName = "";

  /**
   * Description of what columns represent (e.g. "Farbnummer").
   *
   * @generated from field: string columns_description = 11;
   */
  columnsDescription = "";

  /**
   * Row name (e.g. "Menge", "Tester A").
   *
   * @generated from field: string row_name = 12;
   */
  rowName = "";

  /**
   * @generated from field: string model_number = 13;
   */
  modelNumber = "";

  /**
   * @generated from field: string product_name = 14;
   */
  productName = "";

  /**
   * @generated from field: string variant_name = 20;
   */
  variantName = "";

  /**
   * @generated from field: string product_description = 15;
   */
  productDescription = "";

  /**
   * @generated from field: string product_url = 16;
   */
  productUrl = "";

  /**
   * @generated from field: string image_url = 17;
   */
  imageUrl = "";

  /**
   * @generated from field: string created_at = 18;
   */
  createdAt = "";

  /**
   * @generated from field: string updated_at = 19;
   */
  updatedAt = "";

  /**
   * Sub-category for additional grouping (e.g. within "Angebote").
   *
   * @generated from field: string sub_category = 21;
   */
  subCategory = "";

  constructor(data?: PartialMessage<OrderFormProduct>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "mw.common.OrderFormProduct";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "id", kind: "scalar", T: 4 /* ScalarType.UINT64 */ },
    { no: 2, name: "product_id", kind: "scalar", T: 4 /* ScalarType.UINT64 */ },
    { no: 3, name: "product", kind: "message", T: Product },
    { no: 4, name: "order_form", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 5, name: "status", kind: "enum", T: proto3.getEnumType(OrderFormProductStatus) },
    { no: 6, name: "category", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 7, name: "product_line_number", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 8, name: "product_line_name", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 9, name: "product_line_price_definer", kind: "scalar", T: 8 /* ScalarType.BOOL */ },
    { no: 10, name: "column_name", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 11, name: "columns_description", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 12, name: "row_name", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 13, name: "model_number", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 14, name: "product_name", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 20, name: "variant_name", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 15, name: "product_description", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 16, name: "product_url", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 17, name: "image_url", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 18, name: "created_at", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 19, name: "updated_at", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 21, name: "sub_category", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): OrderFormProduct {
    return new OrderFormProduct().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): OrderFormProduct {
    return new OrderFormProduct().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): OrderFormProduct {
    return new OrderFormProduct().fromJsonString(jsonString, options);
  }

  static equals(a: OrderFormProduct | PlainMessage<OrderFormProduct> | undefined, b: OrderFormProduct | PlainMessage<OrderFormProduct> | undefined): boolean {
    return proto3.util.equals(OrderFormProduct, a, b);
  }
}

/**
 * OrderFormProductDisplay combines product data with visibility logic
 * for the admin preview functionality.
 *
 * @generated from message mw.common.OrderFormProductDisplay
 */
export class OrderFormProductDisplay extends Message<OrderFormProductDisplay> {
  /**
   * @generated from field: mw.common.Product product = 1;
   */
  product?: Product;

  /**
   * @generated from field: mw.common.OrderFormProduct order_form_data = 2;
   */
  orderFormData?: OrderFormProduct;

  /**
   * Reasons why this product is hidden (e.g. "blocked", "no stock", "disabled").
   *
   * @generated from field: repeated string hide_reasons = 3;
   */
  hideReasons: string[] = [];

  /**
   * Final visibility result.
   *
   * @generated from field: bool is_visible = 4;
   */
  isVisible = false;

  /**
   * Visually muted but still shown (e.g. low stock).
   *
   * @generated from field: bool is_muted = 5;
   */
  isMuted = false;

  constructor(data?: PartialMessage<OrderFormProductDisplay>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "mw.common.OrderFormProductDisplay";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "product", kind: "message", T: Product },
    { no: 2, name: "order_form_data", kind: "message", T: OrderFormProduct },
    { no: 3, name: "hide_reasons", kind: "scalar", T: 9 /* ScalarType.STRING */, repeated: true },
    { no: 4, name: "is_visible", kind: "scalar", T: 8 /* ScalarType.BOOL */ },
    { no: 5, name: "is_muted", kind: "scalar", T: 8 /* ScalarType.BOOL */ },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): OrderFormProductDisplay {
    return new OrderFormProductDisplay().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): OrderFormProductDisplay {
    return new OrderFormProductDisplay().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): OrderFormProductDisplay {
    return new OrderFormProductDisplay().fromJsonString(jsonString, options);
  }

  static equals(a: OrderFormProductDisplay | PlainMessage<OrderFormProductDisplay> | undefined, b: OrderFormProductDisplay | PlainMessage<OrderFormProductDisplay> | undefined): boolean {
    return proto3.util.equals(OrderFormProductDisplay, a, b);
  }
}

/**
 * PreviewCustomerProfile simulates a customer's product access for admin preview.
 *
 * @generated from message mw.common.PreviewCustomerProfile
 */
export class PreviewCustomerProfile extends Message<PreviewCustomerProfile> {
  /**
   * @generated from field: bool care_products = 1;
   */
  careProducts = false;

  /**
   * @generated from field: bool deco_products = 2;
   */
  decoProducts = false;

  /**
   * @generated from field: bool detox_products = 3;
   */
  detoxProducts = false;

  /**
   * @generated from field: bool hairdresser_products = 4;
   */
  hairdresserProducts = false;

  constructor(data?: PartialMessage<PreviewCustomerProfile>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "mw.common.PreviewCustomerProfile";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "care_products", kind: "scalar", T: 8 /* ScalarType.BOOL */ },
    { no: 2, name: "deco_products", kind: "scalar", T: 8 /* ScalarType.BOOL */ },
    { no: 3, name: "detox_products", kind: "scalar", T: 8 /* ScalarType.BOOL */ },
    { no: 4, name: "hairdresser_products", kind: "scalar", T: 8 /* ScalarType.BOOL */ },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): PreviewCustomerProfile {
    return new PreviewCustomerProfile().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): PreviewCustomerProfile {
    return new PreviewCustomerProfile().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): PreviewCustomerProfile {
    return new PreviewCustomerProfile().fromJsonString(jsonString, options);
  }

  static equals(a: PreviewCustomerProfile | PlainMessage<PreviewCustomerProfile> | undefined, b: PreviewCustomerProfile | PlainMessage<PreviewCustomerProfile> | undefined): boolean {
    return proto3.util.equals(PreviewCustomerProfile, a, b);
  }
}

/**
 * PreviewStatistics shows product visibility counts for admin preview.
 *
 * @generated from message mw.common.PreviewStatistics
 */
export class PreviewStatistics extends Message<PreviewStatistics> {
  /**
   * @generated from field: int32 total_products = 1;
   */
  totalProducts = 0;

  /**
   * @generated from field: int32 visible_products = 2;
   */
  visibleProducts = 0;

  /**
   * @generated from field: int32 hidden_products = 3;
   */
  hiddenProducts = 0;

  /**
   * Breakdown: reason string -> count of products hidden for that reason.
   *
   * @generated from field: map<string, int32> hidden_by_reason = 4;
   */
  hiddenByReason: { [key: string]: number } = {};

  constructor(data?: PartialMessage<PreviewStatistics>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "mw.common.PreviewStatistics";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "total_products", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
    { no: 2, name: "visible_products", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
    { no: 3, name: "hidden_products", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
    { no: 4, name: "hidden_by_reason", kind: "map", K: 9 /* ScalarType.STRING */, V: {kind: "scalar", T: 5 /* ScalarType.INT32 */} },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): PreviewStatistics {
    return new PreviewStatistics().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): PreviewStatistics {
    return new PreviewStatistics().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): PreviewStatistics {
    return new PreviewStatistics().fromJsonString(jsonString, options);
  }

  static equals(a: PreviewStatistics | PlainMessage<PreviewStatistics> | undefined, b: PreviewStatistics | PlainMessage<PreviewStatistics> | undefined): boolean {
    return proto3.util.equals(PreviewStatistics, a, b);
  }
}

/**
 * OrderFormV2Category groups product lines under a category in the V2 layout.
 *
 * @generated from message mw.common.OrderFormV2Category
 */
export class OrderFormV2Category extends Message<OrderFormV2Category> {
  /**
   * @generated from field: string name = 1;
   */
  name = "";

  /**
   * @generated from field: repeated mw.common.OrderFormV2ProductLine product_lines = 2;
   */
  productLines: OrderFormV2ProductLine[] = [];

  constructor(data?: PartialMessage<OrderFormV2Category>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "mw.common.OrderFormV2Category";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "name", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "product_lines", kind: "message", T: OrderFormV2ProductLine, repeated: true },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): OrderFormV2Category {
    return new OrderFormV2Category().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): OrderFormV2Category {
    return new OrderFormV2Category().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): OrderFormV2Category {
    return new OrderFormV2Category().fromJsonString(jsonString, options);
  }

  static equals(a: OrderFormV2Category | PlainMessage<OrderFormV2Category> | undefined, b: OrderFormV2Category | PlainMessage<OrderFormV2Category> | undefined): boolean {
    return proto3.util.equals(OrderFormV2Category, a, b);
  }
}

/**
 * OrderFormV2ProductLine lists products within a product line for V2.
 *
 * @generated from message mw.common.OrderFormV2ProductLine
 */
export class OrderFormV2ProductLine extends Message<OrderFormV2ProductLine> {
  /**
   * Product line number (e.g. "40").
   *
   * @generated from field: string number = 1;
   */
  number = "";

  /**
   * @generated from field: string name = 2;
   */
  name = "";

  /**
   * @generated from field: repeated mw.common.OrderFormProductDisplay products = 3;
   */
  products: OrderFormProductDisplay[] = [];

  constructor(data?: PartialMessage<OrderFormV2ProductLine>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "mw.common.OrderFormV2ProductLine";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "number", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "name", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 3, name: "products", kind: "message", T: OrderFormProductDisplay, repeated: true },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): OrderFormV2ProductLine {
    return new OrderFormV2ProductLine().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): OrderFormV2ProductLine {
    return new OrderFormV2ProductLine().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): OrderFormV2ProductLine {
    return new OrderFormV2ProductLine().fromJsonString(jsonString, options);
  }

  static equals(a: OrderFormV2ProductLine | PlainMessage<OrderFormV2ProductLine> | undefined, b: OrderFormV2ProductLine | PlainMessage<OrderFormV2ProductLine> | undefined): boolean {
    return proto3.util.equals(OrderFormV2ProductLine, a, b);
  }
}

/**
 * OrderFormV2CategoryGrouped is the table-based layout used by the customer
 * frontend. Products are grouped into grids with column headers and rows.
 *
 * @generated from message mw.common.OrderFormV2CategoryGrouped
 */
export class OrderFormV2CategoryGrouped extends Message<OrderFormV2CategoryGrouped> {
  /**
   * Category display title.
   *
   * @generated from field: string title = 1;
   */
  title = "";

  /**
   * @generated from field: repeated mw.common.OrderFormV2ProductGroup product_groups = 2;
   */
  productGroups: OrderFormV2ProductGroup[] = [];

  constructor(data?: PartialMessage<OrderFormV2CategoryGrouped>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "mw.common.OrderFormV2CategoryGrouped";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "title", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "product_groups", kind: "message", T: OrderFormV2ProductGroup, repeated: true },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): OrderFormV2CategoryGrouped {
    return new OrderFormV2CategoryGrouped().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): OrderFormV2CategoryGrouped {
    return new OrderFormV2CategoryGrouped().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): OrderFormV2CategoryGrouped {
    return new OrderFormV2CategoryGrouped().fromJsonString(jsonString, options);
  }

  static equals(a: OrderFormV2CategoryGrouped | PlainMessage<OrderFormV2CategoryGrouped> | undefined, b: OrderFormV2CategoryGrouped | PlainMessage<OrderFormV2CategoryGrouped> | undefined): boolean {
    return proto3.util.equals(OrderFormV2CategoryGrouped, a, b);
  }
}

/**
 * OrderFormV2ProductGroup is a product line displayed as a table.
 *
 * @generated from message mw.common.OrderFormV2ProductGroup
 */
export class OrderFormV2ProductGroup extends Message<OrderFormV2ProductGroup> {
  /**
   * Product line number (e.g. "40").
   *
   * @generated from field: string code = 1;
   */
  code = "";

  /**
   * Product line name (e.g. "Foundation").
   *
   * @generated from field: string title = 2;
   */
  title = "";

  /**
   * Formatted price summary (e.g. "B2B: 12,50 EUR / B2C: 24,95 EUR").
   *
   * @generated from field: string price_info = 3;
   */
  priceInfo = "";

  /**
   * @generated from field: string price_b2b = 4;
   */
  priceB2b = "";

  /**
   * @generated from field: string price_b2c = 5;
   */
  priceB2c = "";

  /**
   * What the columns represent (e.g. "Farbnummer", "Variante").
   *
   * @generated from field: string columns_description = 6;
   */
  columnsDescription = "";

  /**
   * Column headers (e.g. color codes, variant codes).
   *
   * @generated from field: repeated string column_values = 7;
   */
  columnValues: string[] = [];

  /**
   * Table rows (e.g. "Menge", "Tester A", "Tester B").
   *
   * @generated from field: repeated mw.common.OrderFormV2Row rows = 8;
   */
  rows: OrderFormV2Row[] = [];

  /**
   * Sub-category grouping (e.g. "Make-up", "Pflege" within Angebote).
   *
   * @generated from field: string sub_category = 9;
   */
  subCategory = "";

  constructor(data?: PartialMessage<OrderFormV2ProductGroup>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "mw.common.OrderFormV2ProductGroup";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "code", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "title", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 3, name: "price_info", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 4, name: "price_b2b", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 5, name: "price_b2c", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 6, name: "columns_description", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 7, name: "column_values", kind: "scalar", T: 9 /* ScalarType.STRING */, repeated: true },
    { no: 8, name: "rows", kind: "message", T: OrderFormV2Row, repeated: true },
    { no: 9, name: "sub_category", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): OrderFormV2ProductGroup {
    return new OrderFormV2ProductGroup().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): OrderFormV2ProductGroup {
    return new OrderFormV2ProductGroup().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): OrderFormV2ProductGroup {
    return new OrderFormV2ProductGroup().fromJsonString(jsonString, options);
  }

  static equals(a: OrderFormV2ProductGroup | PlainMessage<OrderFormV2ProductGroup> | undefined, b: OrderFormV2ProductGroup | PlainMessage<OrderFormV2ProductGroup> | undefined): boolean {
    return proto3.util.equals(OrderFormV2ProductGroup, a, b);
  }
}

/**
 * OrderFormV2Row is a single row in the product group table.
 *
 * @generated from message mw.common.OrderFormV2Row
 */
export class OrderFormV2Row extends Message<OrderFormV2Row> {
  /**
   * Row label (e.g. "Menge", "Tester A", "Sachet").
   *
   * @generated from field: string name = 1;
   */
  name = "";

  /**
   * Column values where a product is available for ordering.
   *
   * @generated from field: repeated string available_columns = 2;
   */
  availableColumns: string[] = [];

  /**
   * column -> reason why the product is unavailable in that column.
   *
   * @generated from field: map<string, string> unavailable_reasons = 3;
   */
  unavailableReasons: { [key: string]: string } = {};

  /**
   * Formatted prices for this row.
   *
   * @generated from field: string price_b2b = 4;
   */
  priceB2b = "";

  /**
   * @generated from field: string price_b2c = 5;
   */
  priceB2c = "";

  /**
   * column -> product GUID for order submission.
   *
   * @generated from field: map<string, string> product_ids = 6;
   */
  productIds: { [key: string]: string } = {};

  /**
   * column -> SAP model number (shown in product inspector).
   *
   * @generated from field: map<string, string> model_numbers = 7;
   */
  modelNumbers: { [key: string]: string } = {};

  /**
   * column -> INCI ingredients (shown in product inspector).
   *
   * @generated from field: map<string, string> ingredients = 8;
   */
  ingredients: { [key: string]: string } = {};

  /**
   * column -> product description (shown in product inspector).
   *
   * @generated from field: map<string, string> descriptions = 9;
   */
  descriptions: { [key: string]: string } = {};

  /**
   * column -> minimum order quantity for validation.
   *
   * @generated from field: map<string, uint32> minimum_order_quantities = 10;
   */
  minimumOrderQuantities: { [key: string]: number } = {};

  /**
   * Calculated row total based on current quantities.
   *
   * @generated from field: string row_sum = 11;
   */
  rowSum = "";

  /**
   * column -> selected quantity (for calculation).
   *
   * @generated from field: map<string, uint32> quantities = 12;
   */
  quantities: { [key: string]: number } = {};

  /**
   * column -> individual B2B price (only if different from the row-level price).
   *
   * @generated from field: map<string, string> prices_b2b = 13;
   */
  pricesB2b: { [key: string]: string } = {};

  /**
   * column -> individual B2C price (only if different from the row-level price).
   *
   * @generated from field: map<string, string> prices_b2c = 14;
   */
  pricesB2c: { [key: string]: string } = {};

  /**
   * column -> variant name from OrderFormProduct configuration.
   *
   * @generated from field: map<string, string> variant_names = 15;
   */
  variantNames: { [key: string]: string } = {};

  constructor(data?: PartialMessage<OrderFormV2Row>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "mw.common.OrderFormV2Row";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "name", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "available_columns", kind: "scalar", T: 9 /* ScalarType.STRING */, repeated: true },
    { no: 3, name: "unavailable_reasons", kind: "map", K: 9 /* ScalarType.STRING */, V: {kind: "scalar", T: 9 /* ScalarType.STRING */} },
    { no: 4, name: "price_b2b", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 5, name: "price_b2c", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 6, name: "product_ids", kind: "map", K: 9 /* ScalarType.STRING */, V: {kind: "scalar", T: 9 /* ScalarType.STRING */} },
    { no: 7, name: "model_numbers", kind: "map", K: 9 /* ScalarType.STRING */, V: {kind: "scalar", T: 9 /* ScalarType.STRING */} },
    { no: 8, name: "ingredients", kind: "map", K: 9 /* ScalarType.STRING */, V: {kind: "scalar", T: 9 /* ScalarType.STRING */} },
    { no: 9, name: "descriptions", kind: "map", K: 9 /* ScalarType.STRING */, V: {kind: "scalar", T: 9 /* ScalarType.STRING */} },
    { no: 10, name: "minimum_order_quantities", kind: "map", K: 9 /* ScalarType.STRING */, V: {kind: "scalar", T: 13 /* ScalarType.UINT32 */} },
    { no: 11, name: "row_sum", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 12, name: "quantities", kind: "map", K: 9 /* ScalarType.STRING */, V: {kind: "scalar", T: 13 /* ScalarType.UINT32 */} },
    { no: 13, name: "prices_b2b", kind: "map", K: 9 /* ScalarType.STRING */, V: {kind: "scalar", T: 9 /* ScalarType.STRING */} },
    { no: 14, name: "prices_b2c", kind: "map", K: 9 /* ScalarType.STRING */, V: {kind: "scalar", T: 9 /* ScalarType.STRING */} },
    { no: 15, name: "variant_names", kind: "map", K: 9 /* ScalarType.STRING */, V: {kind: "scalar", T: 9 /* ScalarType.STRING */} },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): OrderFormV2Row {
    return new OrderFormV2Row().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): OrderFormV2Row {
    return new OrderFormV2Row().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): OrderFormV2Row {
    return new OrderFormV2Row().fromJsonString(jsonString, options);
  }

  static equals(a: OrderFormV2Row | PlainMessage<OrderFormV2Row> | undefined, b: OrderFormV2Row | PlainMessage<OrderFormV2Row> | undefined): boolean {
    return proto3.util.equals(OrderFormV2Row, a, b);
  }
}

/**
 * SkinProblem defines a skin condition that can be detected by AI or
 * self-reported by users (e.g. "Acne", "Wrinkles", "Dry Skin").
 *
 * @generated from message mw.common.SkinProblem
 */
export class SkinProblem extends Message<SkinProblem> {
  /**
   * @generated from field: uint32 id = 1;
   */
  id = 0;

  /**
   * @generated from field: string name_en = 2;
   */
  nameEn = "";

  /**
   * @generated from field: string name_de = 3;
   */
  nameDe = "";

  /**
   * Detailed description for the user.
   *
   * @generated from field: string description_en = 4;
   */
  descriptionEn = "";

  /**
   * @generated from field: string description_de = 5;
   */
  descriptionDe = "";

  /**
   * Whether AI image analysis can detect this problem.
   *
   * @generated from field: bool ai_detectable = 6;
   */
  aiDetectable = false;

  /**
   * Whether to show a slider for user self-assessment.
   *
   * @generated from field: bool ask_user_input = 7;
   */
  askUserInput = false;

  constructor(data?: PartialMessage<SkinProblem>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "mw.common.SkinProblem";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "id", kind: "scalar", T: 13 /* ScalarType.UINT32 */ },
    { no: 2, name: "name_en", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 3, name: "name_de", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 4, name: "description_en", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 5, name: "description_de", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 6, name: "ai_detectable", kind: "scalar", T: 8 /* ScalarType.BOOL */ },
    { no: 7, name: "ask_user_input", kind: "scalar", T: 8 /* ScalarType.BOOL */ },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): SkinProblem {
    return new SkinProblem().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): SkinProblem {
    return new SkinProblem().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): SkinProblem {
    return new SkinProblem().fromJsonString(jsonString, options);
  }

  static equals(a: SkinProblem | PlainMessage<SkinProblem> | undefined, b: SkinProblem | PlainMessage<SkinProblem> | undefined): boolean {
    return proto3.util.equals(SkinProblem, a, b);
  }
}

/**
 * ProductSkinProblemEffectiveness maps a product's effectiveness score
 * for a specific skin problem (used to generate product recommendations).
 *
 * @generated from message mw.common.ProductSkinProblemEffectiveness
 */
export class ProductSkinProblemEffectiveness extends Message<ProductSkinProblemEffectiveness> {
  /**
   * @generated from field: uint32 id = 1;
   */
  id = 0;

  /**
   * @generated from field: uint32 product_id = 2;
   */
  productId = 0;

  /**
   * Populated in responses.
   *
   * @generated from field: mw.common.Product product = 3;
   */
  product?: Product;

  /**
   * @generated from field: uint32 skin_problem_id = 4;
   */
  skinProblemId = 0;

  /**
   * Populated in responses.
   *
   * @generated from field: mw.common.SkinProblem skin_problem = 5;
   */
  skinProblem?: SkinProblem;

  /**
   * Effectiveness score (0 = not effective, 100 = highly effective).
   *
   * @generated from field: uint32 score = 6;
   */
  score = 0;

  /**
   * @generated from field: string created_at = 7;
   */
  createdAt = "";

  /**
   * @generated from field: string updated_at = 8;
   */
  updatedAt = "";

  constructor(data?: PartialMessage<ProductSkinProblemEffectiveness>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "mw.common.ProductSkinProblemEffectiveness";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "id", kind: "scalar", T: 13 /* ScalarType.UINT32 */ },
    { no: 2, name: "product_id", kind: "scalar", T: 13 /* ScalarType.UINT32 */ },
    { no: 3, name: "product", kind: "message", T: Product },
    { no: 4, name: "skin_problem_id", kind: "scalar", T: 13 /* ScalarType.UINT32 */ },
    { no: 5, name: "skin_problem", kind: "message", T: SkinProblem },
    { no: 6, name: "score", kind: "scalar", T: 13 /* ScalarType.UINT32 */ },
    { no: 7, name: "created_at", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 8, name: "updated_at", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): ProductSkinProblemEffectiveness {
    return new ProductSkinProblemEffectiveness().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): ProductSkinProblemEffectiveness {
    return new ProductSkinProblemEffectiveness().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): ProductSkinProblemEffectiveness {
    return new ProductSkinProblemEffectiveness().fromJsonString(jsonString, options);
  }

  static equals(a: ProductSkinProblemEffectiveness | PlainMessage<ProductSkinProblemEffectiveness> | undefined, b: ProductSkinProblemEffectiveness | PlainMessage<ProductSkinProblemEffectiveness> | undefined): boolean {
    return proto3.util.equals(ProductSkinProblemEffectiveness, a, b);
  }
}

